export type UserV2 = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
};
